module.exports = __webpack_public_path__ + "img/80.cleaning.00fd228b.svg";